import type { Action } from 'redux';
import type { Platform } from '../../../../main/types/links';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateOsPlatform = new ReduxAsyncAction<'UPDATE_OS_PLATFORM', Platform, { osPlatform: Platform }>(
  'UPDATE_OS_PLATFORM'
);

UpdateOsPlatform.registerRequest(async (osPlatform: Platform) => {
  return { osPlatform };
});

export const UPDATE_OS_PLATFORM = UpdateOsPlatform.actionNamespaceConstants;
export const updateOsPlatform = UpdateOsPlatform.request;

export type UpdateOsPlatformResponseAction = Action<typeof UPDATE_OS_PLATFORM.response> & {
  data: { osPlatform: Platform };
};
